import axios from "axios";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  fetchVideoAnalysis: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get("/getVideoAnalysis/" + payload.videoId + "_classified.json")
        .then(function(results) {
          resolve(results.data);
        })
        .catch(function(error) {
          if (error) {
            reject(new Error("cannot fetch video info"));
          }
        });
    });
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
